module.exports = __webpack_public_path__ + "img/battletrip_section5_mo.a4f03053.jpg";